/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { growthGalleryControllerCreate } from '../fn/product-growth-gallery/growth-gallery-controller-create';
import { GrowthGalleryControllerCreate$Params } from '../fn/product-growth-gallery/growth-gallery-controller-create';
import { growthGalleryControllerDelete } from '../fn/product-growth-gallery/growth-gallery-controller-delete';
import { GrowthGalleryControllerDelete$Params } from '../fn/product-growth-gallery/growth-gallery-controller-delete';
import { growthGalleryControllerFindByProductId } from '../fn/product-growth-gallery/growth-gallery-controller-find-by-product-id';
import { GrowthGalleryControllerFindByProductId$Params } from '../fn/product-growth-gallery/growth-gallery-controller-find-by-product-id';
import { growthGalleryControllerTogglePublic } from '../fn/product-growth-gallery/growth-gallery-controller-toggle-public';
import { GrowthGalleryControllerTogglePublic$Params } from '../fn/product-growth-gallery/growth-gallery-controller-toggle-public';
import { growthGalleryControllerUpdate } from '../fn/product-growth-gallery/growth-gallery-controller-update';
import { GrowthGalleryControllerUpdate$Params } from '../fn/product-growth-gallery/growth-gallery-controller-update';
import { GrowthGalleryDto } from '../models/growth-gallery-dto';

@Injectable({ providedIn: 'root' })
export class ProductGrowthGalleryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `growthGalleryControllerCreate()` */
  static readonly GrowthGalleryControllerCreatePath = '/api/growth-galleries';

  /**
   * 성장 갤러리 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthGalleryControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  growthGalleryControllerCreate$Response(params: GrowthGalleryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthGalleryDto>> {
    const obs = growthGalleryControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 성장 갤러리 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthGalleryControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  growthGalleryControllerCreate(params: GrowthGalleryControllerCreate$Params, context?: HttpContext): Observable<GrowthGalleryDto> {
    const resp = this.growthGalleryControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GrowthGalleryDto>): GrowthGalleryDto => r.body)
    );
  }

  /** Path part for operation `growthGalleryControllerDelete()` */
  static readonly GrowthGalleryControllerDeletePath = '/api/growth-galleries/{id}';

  /**
   * 성장 갤러리 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthGalleryControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthGalleryControllerDelete$Response(params: GrowthGalleryControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthGalleryDto>> {
    const obs = growthGalleryControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 성장 갤러리 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthGalleryControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthGalleryControllerDelete(params: GrowthGalleryControllerDelete$Params, context?: HttpContext): Observable<GrowthGalleryDto> {
    const resp = this.growthGalleryControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GrowthGalleryDto>): GrowthGalleryDto => r.body)
    );
  }

  /** Path part for operation `growthGalleryControllerUpdate()` */
  static readonly GrowthGalleryControllerUpdatePath = '/api/growth-galleries/{id}';

  /**
   * 성장 갤러리 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthGalleryControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  growthGalleryControllerUpdate$Response(params: GrowthGalleryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthGalleryDto>> {
    const obs = growthGalleryControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 성장 갤러리 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthGalleryControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  growthGalleryControllerUpdate(params: GrowthGalleryControllerUpdate$Params, context?: HttpContext): Observable<GrowthGalleryDto> {
    const resp = this.growthGalleryControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GrowthGalleryDto>): GrowthGalleryDto => r.body)
    );
  }

  /** Path part for operation `growthGalleryControllerTogglePublic()` */
  static readonly GrowthGalleryControllerTogglePublicPath = '/api/growth-galleries/{id}/toggle-public';

  /**
   * 공개 여부 토글.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthGalleryControllerTogglePublic()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthGalleryControllerTogglePublic$Response(params: GrowthGalleryControllerTogglePublic$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthGalleryDto>> {
    const obs = growthGalleryControllerTogglePublic(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공개 여부 토글.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthGalleryControllerTogglePublic$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthGalleryControllerTogglePublic(params: GrowthGalleryControllerTogglePublic$Params, context?: HttpContext): Observable<GrowthGalleryDto> {
    const resp = this.growthGalleryControllerTogglePublic$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GrowthGalleryDto>): GrowthGalleryDto => r.body)
    );
  }

  /** Path part for operation `growthGalleryControllerFindByProductId()` */
  static readonly GrowthGalleryControllerFindByProductIdPath = '/api/growth-galleries/product/{productId}';

  /**
   * 상품별 성장 갤러리 조회 (전체).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `growthGalleryControllerFindByProductId()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthGalleryControllerFindByProductId$Response(params: GrowthGalleryControllerFindByProductId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GrowthGalleryDto>>> {
    const obs = growthGalleryControllerFindByProductId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품별 성장 갤러리 조회 (전체).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `growthGalleryControllerFindByProductId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  growthGalleryControllerFindByProductId(params: GrowthGalleryControllerFindByProductId$Params, context?: HttpContext): Observable<Array<GrowthGalleryDto>> {
    const resp = this.growthGalleryControllerFindByProductId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<GrowthGalleryDto>>): Array<GrowthGalleryDto> => r.body)
    );
  }

}
